import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "empty", "summary"];

  connect() {
    this.show();
  }

  show() {
    const customerId = this.selectTarget.value;

    this.emptyTarget.hidden = customerId !== "";
    this.summaryTargets.forEach((summary) => {
      summary.hidden = summary.dataset.customerId !== customerId;
    });
  }
}
